import ReactPixel from "react-facebook-pixel";
import UserStore from "../../stores/UserStore"
import { triggerEvent } from "../constants/utils";
import { toJS } from "mobx";

const { makeAutoObservable } = require("mobx");

class QuestionareStore {
  QUESTIONS = []

  currentStepIndex = 0;

  navigate = null;

  totalScores = 0;
  textInputValues = {};
  ratings = {};
  selectedOptions = {};

  constructor() {
    makeAutoObservable(this);
  }

  setQuestions(data){
	  this.QUESTIONS = data
  }

  setTextInputValue(key, value){
	  this.textInputValues[key]= value
  }

  setSelectedOptions(questionKey, selectedIndices){
    this.selectedOptions[questionKey] = selectedIndices;
  }

  setRatingValue(key, value){
    this.ratings[key] = value
  }

  getTextInputValue(key){
    return this.textInputValues[key] || ""
  }

  getRatingValue(key){
    return this.ratings[key] || 3
  }

  selectOption(optionIndex) {
    const questionKey = this.currentStepIndex;
    const isMultiSelectStep =
      this.QUESTIONS[questionKey].select_type === "multi_select";
    let selected = this.selectedOptions[questionKey] || [];

    if (isMultiSelectStep) {
      if (selected.includes(optionIndex)) {
        selected = selected.filter(idx => idx !== optionIndex);
      } else {
        selected = [...selected, optionIndex];
      }
    } else {
      this.clearCurrentSelections();
      selected = [optionIndex];
    }

    this.setSelectedOptions(questionKey, selected);

    // Update isSelected for UI rendering
    this.QUESTIONS[questionKey].options.forEach((option, idx) => {
      option.isSelected = selected.includes(idx);
    });

    this.QUESTIONS[questionKey].isComplete = this.isStepComplete();
    triggerEvent("Option_Select_prctn", {
      question: this.QUESTIONS[questionKey].question,
      value: this.QUESTIONS[questionKey].options[optionIndex].text,
    });
  }

  setNavigation(navigate) {
    this.navigate = navigate;
  }

  handleBackPress = () => {
    triggerEvent("Question_Back", {
      question: this.QUESTIONS[this.currentStepIndex],
      question_no: this.currentStepIndex + 1,
    });
    this.currentStepIndex -= 1;
  };

  handleNextPress = () => {
    if (this.currentStepIndex >= this.QUESTIONS.length-1) {
      this.navigate("/phone_screen");
      // this.navigate("/metrics");
      // this.navigate("/signup_options")
      // this.navigate("/signup")
      return;
    }

    if(this.QUESTIONS[this.currentStepIndex].select_type==="text_textarea"){
      console.log(this.textInputValue);
    }

    //save screen data to tb_user_ic_content
    let selected_option = [] 
    this.QUESTIONS[this.currentStepIndex].options.map((item) => {
      if (item.isSelected) {
        selected_option = toJS(item)
      }
    });
    const data = {
      screen_option: selected_option
    }  

    triggerEvent("Question_Next", {
      question: this.QUESTIONS[this.currentStepIndex],
      question_no: this.currentStepIndex + 1,
    });
    this.currentStepIndex += 1;
  };

  isStepComplete = () => {
    let isComplete = false;
    if(this.QUESTIONS[this.currentStepIndex].screen_type === 'output') return true;
    this.QUESTIONS[this.currentStepIndex].options.map((item) => {
      if (item.isSelected) {
        isComplete = true;
      }
    });

    return isComplete;
  };

  isNextButtonDisabled = (isQuestion) => {
    //email input screen
    if (this.currentStepIndex == this.QUESTIONS.length) {
      return !UserStore.email || !UserStore.isEmailValid;
    } 
    else if(this.QUESTIONS[this.currentStepIndex].screen_type == "output") {
      return false;
    }
    else if(this.QUESTIONS[this.currentStepIndex].screen_type == "display") return false;
    else if(this.QUESTIONS[this.currentStepIndex].select_type === "range_select_5" || 
      this.QUESTIONS[this.currentStepIndex].select_type === 'range_select_10'
    ){
      return false;
    }
    else if (isQuestion) {
      return !((this.selectedOptions[this.currentStepIndex] || []).length > 0);
    }
    //information screens
    else {
      return false;
    }
  };

  clearCurrentSelections = () => {
    this.QUESTIONS[this.currentStepIndex].options.map((item, index) => {
      this.QUESTIONS[this.currentStepIndex].options[index].isSelected = false;
    });
  };

  getTotalScore = () => {
    let scores = 0;

    this.QUESTIONS?.map((item) => {
      item?.options?.map((option) => {
        if (option.isSelected) {
          scores += option.score;
        }
      });
    });

    this.totalScores = scores;
  };
}

export default new QuestionareStore();
